export type LanguageCode = 'ar' | 'en' | 'tr' | 'ru' | 'ko' | 'zh-CN' | 'uk' | 'fa';
export type LanguageDirection = 'ltr';

export interface LanguageMeta {
    code: LanguageCode;
    label: string;
    flag: string;
    dir: LanguageDirection;
}

export const LANGUAGES: Record<LanguageCode, LanguageMeta> = {
    ar: { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'ltr' },
    en: { code: 'en', label: 'English', flag: '🇺🇸', dir: 'ltr' },
    tr: { code: 'tr', label: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
    ru: { code: 'ru', label: 'Русский', flag: '🇷🇺', dir: 'ltr' },
    ko: { code: 'ko', label: '한국어', flag: '🇰🇷', dir: 'ltr' },
    'zh-CN': { code: 'zh-CN', label: '中文', flag: '🇨🇳', dir: 'ltr' },
    uk: { code: 'uk', label: 'Українська', flag: '🇺🇦', dir: 'ltr' },
    fa: { code: 'fa', label: 'فارسی', flag: '🇮🇷', dir: 'ltr' },
};

export const SUPPORTED_LANGS = Object.keys(LANGUAGES) as LanguageCode[];
export const DEFAULT_LANGUAGE: LanguageCode = 'en';
export const LANGUAGE_STORAGE_KEY = 'kite_language';

export const RTL_LANGS: LanguageCode[] = [];

export function isRtl(_language?: string): boolean {
    return false;
}

export function getLanguageDir(_language?: string): LanguageDirection {
    return 'ltr';
}

export function isValidLanguage(code: string | null | undefined): code is LanguageCode {
    return !!code && code in LANGUAGES;
}